import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_TEAM_MEMBER,
  FETCH_TEAM_MEMBER_LIST,
  FIND_ALL_TEAM_MEMBER,
} from './teamMember.actions';
import { TeamMember, TeamMemberState } from './teamMember.type';

const initialState: TeamMemberState = {
  errorMessage: '',
  item: {} as Readonly<TeamMember>,
  items: [] as ReadonlyArray<TeamMember>,
  loading: false,
  totalItems: 0,
  selectedItems: [] as TeamMember[],
};

export default (
  state: TeamMemberState = initialState,
  action: AppAction,
): TeamMemberState => {
  switch (action.type) {
    case REQUEST(FETCH_TEAM_MEMBER_LIST):
    case REQUEST(FIND_ALL_TEAM_MEMBER):
      return { ...state, loading: true };
    case SUCCESS(FETCH_TEAM_MEMBER_LIST):
    case SUCCESS(FIND_ALL_TEAM_MEMBER):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_TEAM_MEMBER_LIST):
    case FAILURE(FIND_ALL_TEAM_MEMBER):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };

    case CLEAR_TEAM_MEMBER:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
